import React, { useEffect, useState } from 'react';
import { View } from "react-native";
import Colors from '../../constants/Colorsv2';
import { TeamProps } from '../../store/types/sr_svc';
import { BEEventApi, EventComponents } from 'be-components';
import { event_activateEvent, event_getTeamByIdNoStore } from '../../store/actionsv1/events';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import { market_getLatestTradesByEventId, market_setDraftOrder } from '../../store/actionsv1/markets';
import { V1_LOAD_EXTERNAL_PRICE_COMPARISON } from '../../store/actionsv1/types';
import { TradeProps } from '../../store/types/mk_svc';


const TeamScreen = ({ route, navigation }:any) => {
    const [ activate_loading, setActivateLoading ] = useState(false);
    const [ team, setTeam ] = useState<TeamProps | undefined>(undefined);

    const dispatch = useDispatch();
    const player = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    const bottom_tab_height = useSelector((state:any) => state.util.bottom_tab_height, (left, right) => left == right);
    const header_height = useSelector((state:any) => state.util.header_height, (left, right) => left == right);
    const app_size = useSelector((state:any) => state.util.app_size, (left, right) => left.height == right.height);
    //const insets = useSafeAreaInsets();


    useEffect(() => {
        if(!route.params?.team_id){ return }
        getData(route.params.team_id);
    },[route.params?.team_id]);

    const getData = async(id:string) => {
        const team = await event_getTeamByIdNoStore(id);
        setTeam(team);
    }

    const handleActivateEvent = async(event_id:string) => {
        setActivateLoading(true);
        await dispatch(event_activateEvent(event_id))
        setTimeout(() => {
            handleRefreshTrades(event_id)
        }, 3000);
    }

    const handleRefreshTrades = async(event_id:string) => {
        await dispatch(market_getLatestTradesByEventId(event_id, 'team'))
        setActivateLoading(false)
    }
    return (
        <View style={{ flex:1, backgroundColor:Colors.shades.white }}>
            {team ?
            <Helmet>
                <title>{team.market_name} {team.name} Betting Markets</title>
                <meta name='description' content={`BettorEdge betting markets for the ${team.market_name} ${team.name}`} />
                <meta name='og:image' content={team.image?.url} />
            </Helmet>
            :<></>}
            <EventComponents.TeamProfile
                team_id={route.params.team_id}
                height={app_size.height - bottom_tab_height - header_height}
                onEvent={(be_event) => BEEventApi.saveEvent(be_event)}
                activate_loading={activate_loading}
                onActivate={player?.role == 'admin' ? (event_id) => handleActivateEvent(event_id) :undefined}
                onTradeLongPress={(trade:TradeProps) => {
                    dispatch({ 
                        type: V1_LOAD_EXTERNAL_PRICE_COMPARISON, 
                        external_price_comparison: {
                            event_id:trade.event_id,
                            event_type:trade.event_type,
                            init_market:trade.market,
                            side: trade.side,
                            participant_id: trade.market?.level == 'event' ? undefined : trade.side_id,
                            participant_type: trade.market?.level == 'event' ? undefined : trade.side_type
                        }  
                    }) 
                }}
                
                onTeamSelect={(team_id) => navigation.push('Team', { team_id:team_id })}
                onOrder={(order) => dispatch(market_setDraftOrder(order))}
                onViewAdditionalMarkets={(event_id) => navigation.push('AdditionalMarkets', { event_id: event_id })}
                onViewEvent={(d) => navigation.push('Market', { event_id:d.event_id, event_type: d.event_type, market_id: d.market_id, participant_type:d.side_type, participant_id:d.side_id })}
                onCompetitionSelect={(competition_id) => navigation.navigate('CompetitionStack', { screen: 'CompetitionPlay', initial:false, params: { competition_id } })}
                onSquaresSelect={(sq_comp_id) => navigation.navigate(`CompetitionStack`, { screen: 'SquaresPlay', initial:false, params:{ sq_comp_id } })}
            />
        </View>
    )
}

export default TeamScreen